import React, { useState } from "react";
import { Box, Typography, Divider } from "@mui/material";
import FactionRankingTable from "./FactionRankingTable";
import GhostDeerIndex from "./GhostDeerIndex";
import {
  BCPListOl,
  BCPChartMixed
} from "../../../components/icons/bcp/BCPIcons";

const TABS = [
  { index: 0, Icon: BCPListOl },
  { index: 1, Icon: BCPChartMixed }
];

export default function FactionRankings({
  label,
  data,
  theme,
  onAnalyze,
  childRecordType,
  childLabel
}) {
  const [activeTab, setActiveTab] = useState(0);

  if (!data || !data.rows || data.rows.length === 0) return null;

  const isDark = theme.palette.mode === "dark";
  const borderColor = isDark ? "rgba(255,255,255,0.08)" : "rgba(0,0,0,0.08)";
  const contentBg = isDark ? "rgba(255,255,255,0.05)" : "rgba(0,0,0,0.02)";
  const headerBg = isDark ? "rgba(255,255,255,0.02)" : "rgba(0,0,0,0.015)";
  const tabColor = isDark ? "#3b82f6" : "#2563eb";

  return (
    <Box sx={{ mt: 6 }}>
      <Divider
        sx={{
          mb: 4,
          borderColor: borderColor
        }}
      />

      <Typography
        variant="h5"
        sx={{
          mb: 3,
          color: theme.palette.text.primary,
          fontWeight: 600,
          textAlign: "center",
          letterSpacing: "0.05em"
        }}
      >
        {label || "Faction"} Rankings
      </Typography>

      <Box
        sx={{
          border: `1px solid ${borderColor}`,
          borderRadius: 1,
          boxShadow: isDark
            ? "0 2px 8px rgba(0,0,0,0.3)"
            : "0 2px 8px rgba(0,0,0,0.1)",
          overflow: "hidden"
        }}
      >
        <Box
          sx={{
            display: "flex",
            backgroundColor: headerBg,
            borderBottom: `1px solid ${borderColor}`
          }}
        >
          {TABS.map(({ index, Icon }) => {
            const isActive = activeTab === index;
            return (
              <Box
                key={index}
                onClick={() => setActiveTab(index)}
                sx={{
                  flex: 1,
                  px: 2.5,
                  py: 1.5,
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: isActive ? tabColor : theme.palette.text.secondary,
                  backgroundColor: isActive ? contentBg : "transparent",
                  borderRight: `1px solid ${borderColor}`,
                  borderTop: isActive
                    ? `2px solid ${tabColor}`
                    : "2px solid transparent",
                  marginBottom: isActive ? "-1px" : 0,
                  borderBottom: isActive ? `1px solid ${contentBg}` : "none",
                  transition: "color 0.15s ease, background-color 0.15s ease",
                  "&:hover": {
                    color: isActive ? tabColor : theme.palette.text.primary,
                    backgroundColor: isActive
                      ? contentBg
                      : isDark
                        ? "rgba(255,255,255,0.04)"
                        : "rgba(0,0,0,0.03)"
                  }
                }}
              >
                <Icon size="md" />
              </Box>
            );
          })}
        </Box>

        {activeTab === 0 && (
          <Box
            sx={{
              backgroundColor: contentBg,
              "& > .MuiTableContainer-root": {
                border: "none",
                borderRadius: 0,
                boxShadow: "none",
                backgroundColor: "transparent"
              }
            }}
          >
            <FactionRankingTable
              label={label}
              rows={data.rows}
              theme={theme}
              onAnalyze={onAnalyze}
              childRecordType={childRecordType || "subFaction"}
              childLabel={childLabel || "Leaders"}
            />
          </Box>
        )}

        {activeTab === 1 && (
          <Box sx={{ backgroundColor: contentBg }}>
            <GhostDeerIndex rows={data.rows} theme={theme} disableContainer />
          </Box>
        )}
      </Box>
    </Box>
  );
}
